import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import classes from '../DocumentTypeField.module.css';
export const ComboBoxValue = ({ item }) => {
    return (_jsxs(_Fragment, { children: [item.code, "\u00A0", _jsx("span", { className: classes.secondary, children: item.name })] }));
};
